import { useState, useEffect } from 'react'
import { nanoid } from 'nanoid'
import { useSelector } from 'react-redux'
import { useSpring } from 'react-spring'
import SelectorButton from './SelectorButton'

import './Selectors.css'

const Selectors = ({ calcNextMessage, newSelectors, open, setOpen }) => {
    const [selectors, setSelectors] = useState([])
    const [containerWidth, setContainerWidth] = useState(null)
    const role = useSelector(state => state.role)

    useEffect(() => {
        setSelectors(newSelectors)
    }, [newSelectors])

    useEffect(() => {
        //setOpen(true)
    }, [selectors])

    useEffect(() => {
        if (document.getElementById('game-container-id')) {
            //console.log(document.getElementById('game-container-id').offsetWidth)
            setContainerWidth(document.getElementById('game-container-id').offsetWidth)
        }
    }, [])

    const select = (choice) => {
        setOpen(false)

        const timeoutOne = setTimeout(() => {
            calcNextMessage(choice)
        }, 500)

        return () => {
            clearTimeout(timeoutOne)
        }
    }

    const selectorStyle = useSpring(
        {
            width: open ? '86%' : '0%',
            //transform: open ? 'translateX(0em)' : 'translateX(3em)',
        }
    )

    const iconStyle = useSpring(
        {
            transform: open ? 'translateX(6vh)' : 'translateX(32vh)',
            /*
            config: {
                //tension: 100,
                //mass: 2,
                //friction: 20,
            }
            */
        }
    )

    /*
    TODO: laske containerWidthistä
    const iconSmall = useSpring(
        {
            transform: open ? 'translateX(6vh)' : 'translateX(30vh)',
            config: {
                //tension: 100,
                mass: 2,
                //friction: 20,
            }
        }
    )
    */

    const style = `${role === 'seller' ? 'seller' : 'buyer'}-selector`

    return (
        <div className='selectors-container general-container'>
            {selectors.map(selector =>
                <SelectorButton key={nanoid()}
                    springLogoStyle={iconStyle}
                    springStyle={selectorStyle}
                    selector={selector}
                    style={style}
                    disabled={!open}
                    role={role}
                    onClick={() => open && select(selector)} />)
            }
        </div>
    )
}

export default Selectors